export const fontStyleDefault = Object.freeze({ name: 'Arial', sz: 10 })

export const cellStylesNormal = {
  alignment: { wrapText: false },
}

export const cellStylesTextCenter = {
  alignment: { wrapText: false, horizontal: 'left', vertical: 'center' },
}

export const cellStylesLineBottom = {
  alignment: { wrapText: false, horizontal: 'center', vertical: 'center' },
  bottom: { style: 'thin', color: { rgb: 0x000000 } },
}

export const cellStylesTitle = {
  alignment: { wrapText: false, horizontal: 'center', vertical: 'center' },
  bottom: { style: 'thin', color: { rgb: 0x000000 } },
  left: { style: 'thin', color: { rgb: 0x000000 } },
  right: { style: 'thin', color: { rgb: 0x000000 } },
  top: { style: 'thin', color: { rgb: 0x000000 } },
}
